/** Series colours of the channels in the charts, as the prototype draws them (not status colours). */
export const CHANNEL_COLORS: Record<string, string> = {
  meta: '#6657d8',
  google: '#3478e5',
  sklik: '#de9d32',
  email: '#00a879',
};
